import Vue from "vue";
import Vuex from "vuex";
import { changeLocale } from "@/i18n";
import { defaultLocal } from "@/i18n";

Vue.use(Vuex);

// modules
import vod from "./modules/vod";
import live from "./modules/live";
import player from "./modules/player";

export interface StateIndex {
  // themeColor?: string;
  activeLanguage: string;
  langs: string[];
  programSubscribeList: any[];
  purchaseDialogVisible: boolean;
  activeCardDetail: any;
  showMarqueeStatus: boolean;
  freeTrialStatus: boolean;
  freeTrialDays: number;
  logo: string;
  profileListUpdate: boolean;
}

// 保存默认 state 值，用于退出登录时重置
const defaultState = {
  programSubscribeList: [],
  // themeColor: sessionStorage.getItem("themeColor") || "",
  activeLanguage: defaultLocal,
  langs: [],
  purchaseDialogVisible: false,
  activeCardDetail: null, // 确保页面只同时存在一个卡片弹窗
  showMarqueeStatus: false, // 是否展示跑马灯
  freeTrialStatus: false, // 是否领取7天试用期
  freeTrialDays: 0, // 领取天试用期天数
  logo: "",
  profileListUpdate: false, // 是否更新profile列表数据
};

export default new Vuex.Store({
  state: {
    programSubscribeList: [],
    // themeColor: sessionStorage.getItem("themeColor") || "",
    activeLanguage: defaultLocal,
    langs: [],
    purchaseDialogVisible: false,
    activeCardDetail: null, // 确保页面只同时存在一个卡片弹窗
    showMarqueeStatus: false, // 是否展示跑马灯
    freeTrialStatus: false, // 是否领取7天试用期
    freeTrialDays: 0, // 领取天试用期天数
    logo: "",
    profileListUpdate: false, // 是否更新profile列表数据
  },
  getters: {
    activeLanguage: (state: StateIndex) => {
      return state.activeLanguage;
    },
    programSubscribeList: (state: StateIndex) => {
      return state.programSubscribeList;
    },
    langList: (state: StateIndex) => {
      return state.langs;
    },
    purchaseDialogVisible: (state: StateIndex) => {
      return state.purchaseDialogVisible;
    },
    activeCardDetail: (state: StateIndex) => {
      return state.activeCardDetail;
    },
    showMarqueeStatus: (state: StateIndex) => {
      return state.showMarqueeStatus;
    },
    freeTrialStatus: (state: StateIndex) => {
      return state.freeTrialStatus;
    },
    freeTrialDays: (state: StateIndex) => {
      return state.freeTrialDays;
    },
    logo: (state: StateIndex) => {
      return state.logo;
    },
    profileListUpdate: (state: StateIndex) => {
      return state.profileListUpdate;
    },
  },
  mutations: {
    // 切换多语言
    set_active_language(state: StateIndex, language: string) {
      changeLocale(language);
      state.activeLanguage = language;
    },
    // 当下需要弹出的epg预约提示列表
    set_program_notify_list(state: StateIndex, list: any[]) {
      state.programSubscribeList = list;
    },
    set_langs(state: StateIndex, langs: []) {
      state.langs = langs;
    },
    set_purchase_dialog_visible(state: StateIndex, visible: any) {
      state.purchaseDialogVisible = visible;
    },
    set_active_card_detail(state: StateIndex, cardId: any) {
      state.activeCardDetail = cardId;
    },
    set_show_marquee_status(state: StateIndex, status: boolean) {
      state.showMarqueeStatus = status;
    },
    set_free_trial_status(state: StateIndex, status: boolean) {
      state.freeTrialStatus = status;
    },
    set_free_trial_days(state: StateIndex, days: number) {
      state.freeTrialDays = days;
    },
    set_logo(state: StateIndex, logo: string) {
      state.logo = logo;
    },
    set_profile_list_update(state: StateIndex, update: boolean) {
      state.profileListUpdate = update;
    },
    // 重置 state 为默认值（退出登录时使用）
    resetState(state: StateIndex) {
      // 保存当前 logo 值，不恢复默认
      const currentLogo = state.logo;
      Object.assign(state, defaultState);
      // 恢复 logo 值
      state.logo = currentLogo;
    },
  },
  modules: {
    vod,
    live,
    player,
  },
});
